import { render } from "./AccessError.vue?vue&type=template&id=1407385b&scoped=true"
import script from "./AccessError.vue?vue&type=script&lang=js"
export * from "./AccessError.vue?vue&type=script&lang=js"

import "./AccessError.vue?vue&type=style&index=0&id=1407385b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1407385b"]])

export default __exports__